import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletSeed.module.css'
import classNames from 'classnames'
import Seed from '@/components/seed'

import CreateWalletTitle from '../create-wallet-title'
import CreateWalletHeader from '../create-wallet-header'
import CreateWalletFooter from '../create-wallet-footer'

const CreateWalletSeed: FC<{
	step: number
	seed: string
	totalSteps: number
	onNext: (evt: any) => void
	onBack: (evt: any) => void
}> = ({ step, seed, onNext, onBack, totalSteps }): ReactElement => {
	//React.useEffect(() => {
	//async function init() {
	//const data = await getSeed()
	//console.log({ data })
	//}

	//init();
	//}, []);

	return (
		<>
			<CreateWalletHeader
				step={step}
				total={totalSteps}
				nextDisabled={false}
				onNext={onNext}
				onBack={onBack}
			/>
			<div className={styles.root}>
				<CreateWalletTitle step={step} />
				<p className={classNames(styles.warning, 'text-md', 'bold')}>Store it somewhere safe!</p>
				<Seed seed={seed} />
			</div>
			<CreateWalletFooter step={step} nextDisabled={false} onNext={onNext} onBack={onBack} />
		</>
	)
}

export default CreateWalletSeed
